import React from 'react';

import classes from './SearchInput.module.css';

export default function SearchInput({
  value = '',
  onChange,
  placeholder = 'Start searching...',
  style,
}) {
  return (
    <input
      className={classes.input}
      style={style}
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
